import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  radii,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export const sidebarLinkStyles = stylex.create({
  row: {
    display: "flex",
    height: 36,
    alignItems: "center",
    gap: spacing.space12,
    paddingInline: spacing.space12,
    borderRadius: radii.small,
    fontFamily: fonts.sans,
    fontSize: fontSizes.label,
    lineHeight: "21px",
    letterSpacing: "0.3px",
    textDecoration: "none",
    transitionProperty: "background-color, color",
    transitionDuration: "100ms",
  },
  active: {
    backgroundColor: colors.action,
    color: colors.foreground,
    fontWeight: 500,
  },
  resting: {
    backgroundColor: { default: "transparent", ":hover": colors.hover },
    color: colors.secondary,
    fontWeight: 400,
  },
});
